import { render, staticRenderFns } from "./CreateProductNew.vue?vue&type=template&id=5b0c764a&scoped=true&"
import script from "./CreateProductNew.vue?vue&type=script&lang=js&"
export * from "./CreateProductNew.vue?vue&type=script&lang=js&"
import style0 from "./CreateProductNew.vue?vue&type=style&index=0&id=5b0c764a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b0c764a",
  null
  
)

export default component.exports